import { applyFormat } from "components/ui/ui-helpers";
import React from "react";
import { FaUser, FaFileContract, FaMoneyBillWave, FaFileInvoiceDollar } from "react-icons/fa";
import CompactFinancialCard from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";

const RemunerationTNS = (props) => {
  let {Resultat, Prenom} = props;
  
  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',
      border: '1px solid rgba(0,0,0,0.06)',
      margin: '5px 0'
    }}>
      {/* Titre de section */}
      <div style={{
        fontSize: '12px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: 600,
        color: '#1f2937',
        margin: '0 0 4px 0',
        letterSpacing: '-0.02em'
      }}>
        Rémunération TNS
      </div>
      
      {/* Sous-titre */}
      <div style={{
        fontSize: '12px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: 400,
        color: '#6b7280',
        margin: '0 0 12px 0',
        letterSpacing: '-0.01em',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        paddingBottom: '8px'
      }}>
        Détail de la rémunération pour {Prenom}
      </div>

      {/* Cartes financières compactes */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        
        <CompactFinancialCard
          title={`Budget rémunération pour ${Prenom}`}
          value={applyFormat(Resultat.CoutRemuneration, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          icon={<FaUser style={{ color: '#059669' }} />}
          accentColor="#059669"
        />

        <CompactFinancialCard
          title="Cotisations obligatoires et facultatives"
          value={applyFormat(Number(Resultat.TotalChargesSociales)+Number(Resultat.CotisationsFacultativesEntreprise), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          icon={<FaFileContract style={{ color: '#dc2626' }} />}
          accentColor="#dc2626"
        />

        <CompactFinancialCard
          title="Rémunération nette"
          value={applyFormat(Resultat.RemunerationNette, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          icon={<FaMoneyBillWave style={{ color: '#2563eb' }} />}
          accentColor="#2563eb"
        />

        <CompactFinancialCard
          title="Rémunération imposable"
          value={applyFormat(Resultat.BrutImposable, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          icon={<FaFileInvoiceDollar style={{ color: '#2563eb' }} />}
          accentColor="#2563eb"
        />
      </div>
    </div>
  );
};

export default RemunerationTNS;
